import { render, staticRenderFns } from "./field-select-wd.vue?vue&type=template&id=ababe890&scoped=true"
import script from "./field-select-wd.vue?vue&type=script&lang=js"
export * from "./field-select-wd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ababe890",
  null
  
)

export default component.exports